export default __webpack_public_path__ + "static/media/thumbnail_image_1.465df4d9.png";